import { trackSeoEvent } from "./buyerAnalytics";
import { BUYER_ANALYTICS_EVENTS } from "../constants/automapAnalyticsEvents";

const SEO_EVENT_BRIDGE = {
  seo_page_viewed: BUYER_ANALYTICS_EVENTS.SEO_PAGE_VIEWED,
  seo_content_page_viewed: BUYER_ANALYTICS_EVENTS.SEO_PAGE_VIEWED,
  seo_inventory_card_clicked: BUYER_ANALYTICS_EVENTS.SEO_INVENTORY_CARD_CLICKED,
  seo_landing_inventory_clicked: BUYER_ANALYTICS_EVENTS.SEO_INVENTORY_CARD_CLICKED,
  seo_filter_clicked: "seo_related_search_clicked",
  seo_related_link_clicked: "seo_related_search_clicked",
  seo_related_search_clicked: "seo_related_search_clicked",
  seo_buyer_quiz_clicked: "seo_quiz_cta_clicked",
  seo_quiz_cta_clicked: "seo_quiz_cta_clicked",
  seo_checklist_clicked: "seo_checklist_cta_clicked",
  seo_checklist_cta_clicked: "seo_checklist_cta_clicked",
  seo_dealer_clicked: "dealer_directory_card_clicked",
  seo_dealer_profile_clicked: "dealer_profile_viewed",
  seo_guide_clicked: "seo_guide_clicked",
  seo_guide_cta_clicked: BUYER_ANALYTICS_EVENTS.GUIDE_CTA_CLICKED,
  seo_no_inventory_cta_clicked: "seo_quiz_cta_clicked",
  seo_page_no_inventory_viewed: BUYER_ANALYTICS_EVENTS.SEO_PAGE_VIEWED,
};

export function trackSeoPageEvent(eventType, metadata = {}) {
  const eventName = SEO_EVENT_BRIDGE[eventType] || eventType;
  trackSeoEvent(eventName, metadata);
}

export const SEO_ANALYTICS_EVENTS = {
  PAGE_VIEWED: "seo_page_viewed",
  CONTENT_PAGE_VIEWED: "seo_content_page_viewed",
  INVENTORY_CARD_CLICKED: "seo_inventory_card_clicked",
  LANDING_INVENTORY_CLICKED: "seo_landing_inventory_clicked",
  FILTER_CLICKED: "seo_filter_clicked",
  RELATED_LINK_CLICKED: "seo_related_link_clicked",
  RELATED_SEARCH_CLICKED: "seo_related_search_clicked",
  BUYER_QUIZ_CLICKED: "seo_buyer_quiz_clicked",
  QUIZ_CTA_CLICKED: "seo_quiz_cta_clicked",
  CHECKLIST_CLICKED: "seo_checklist_clicked",
  CHECKLIST_CTA_CLICKED: "seo_checklist_cta_clicked",
  DEALER_CLICKED: "seo_dealer_clicked",
  DEALER_PROFILE_CLICKED: "seo_dealer_profile_clicked",
  GUIDE_CLICKED: "seo_guide_clicked",
  GUIDE_CTA_CLICKED: "seo_guide_cta_clicked",
  NO_INVENTORY_CTA_CLICKED: "seo_no_inventory_cta_clicked",
  PAGE_NO_INVENTORY_VIEWED: "seo_page_no_inventory_viewed",
};
